import styled from '@emotion/styled';
import { AlumniSansFont, RobotoFont } from '../../../styles/fonts';

export const FormContainer = styled.div<any>(
  ({ forModal }) => `
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: ${forModal ? '0 30.45px 0 36px' : '0 96px'};
  font-family: ${RobotoFont.style.fontFamily}, sans-serif;
  position: relative;

  .page-link {
    position: absolute;
    left: 100px;
    top: 18px;
    @media screen and (max-width: 768px) {
      display: none;
    }

    .link:hover {
      text-decoration: underline;
      text-decoration-thickness: 1px;
      cursor: pointer;
    }
  }

  .title {
    margin: 70px 0 38px;
    @media screen and (max-width: 768px) {
      margin: 48px 0 24px;
    }
  }

  .titleForModal {
    font-weight: 450;
    font-size: 36px;
    line-height: 44px;
    margin: 46px 0 32px;
    @media screen and (max-width: 768px) {
      margin: 46px 0 24px;
    }
  }

  .step-container {
    display: flex;
    flex-direction: row;
    gap: 14px;
    width: 606px;
    @media screen and (max-width: 768px) {
      max-width: 294px;
    }
  }

  .step-item {
    display: flex;
    flex-direction: row;
    gap: 10px;
    cursor: pointer;
    color: #D7D7D7;
    width: 100%;
    border-bottom: 1px solid #181818;
    padding-bottom: 14px;
    margin-bottom: 32px;
  }

  .step-item-active {
    color: #181818;
  }

  .step-item-succesfull {
    color: #0A9418;
    border-bottom: 1px solid #0A9418;
  }

  .button-next {
    width: 100%;
    height: 48px; 
    margin-top: 14px;
    margin-bottom: 150px;
    @media screen and (max-width: 768px) {
      margin-top: 12px;
    }
  }

  .button-cancel {
    width: 100%;
    height: 48px; 
    margin: 10px 0 48px;
  }

  .button-submit {
    width: 100%;
    height: 48px; 
    margin: 10px 0 48px;
  }
  .button-submit:hover {
    background: white;
    color: #181818 !important;
  }

  .form-container,
  .form-item-container,
  .custom-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${forModal ? '100%' : '608px'};
  }

  .form-container {
    margin-bottom: ${forModal ? '0' : '24px'};
  }

  .form-item-container {
    width: 100%;
    gap: 18px;
    @media screen and (max-width: 768px) {
      gap: 12px;
    }
  }

  .custom-form {
    width: 100%;
    padding: 0;
    gap: 18px;
    @media screen and (max-width: 768px) {
      gap: 12px;
      padding: 0 0 24px;
    }
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 18px;
  }
  .form-row-for-modal {
    margin-top: 18px;
  }

  .input-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .form-flex-row {
    flex-direction: row;
    gap: 10px;
    @media screen and (max-width: 768px) {
      gap: 12px;
    }
  }

  .input-wrapper-right {
    flex: 1;
    margin-left: ${forModal ? '0' : '0'};
  }

  .form-label {
    color: #0d0d0e;
    font-size: 24px;
    font-weight: 700;
    margin: ${forModal ? '0 0 24px 0' : '48px 0'};  
    align-self: center;
    white-space: nowrap;
  }

  .step-label {
    font-family: ${AlumniSansFont.style.fontFamily}, sans-serif;
    color: #181818;
    font-size: 24px;
    line-height: 29px;
    font-weight: 400;
    letter-spacing: 1px;

  }

  .input-label,
  .info-label {
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    color: #484E57;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin: 12px 0 8px 0;
  }

  .input-label-for-modal {
    font-size: 18px;
    line-height: 22px;
    color: #535353;
  }

  .info-label {
    padding-bottom: 24px;
  }

  .big-label {
    text-transform: uppercase;
  }

  .checkbox-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .checkbox {
    border: 1px solid #E7E6E6;
    border-radius: 4px;
    max-height: 18px;
    max-width: 18px;
    margin: 0 8px 0 11px;
    &.Mui-checked: {
      color: #181818;
    }
  }

  .checkbox-for-modal {
    border: 0px;
    border-radius: 0px;
    max-height: 21px;
    max-width: 21px;
    margin: 0 8px 0 11px;    
    &.Mui-checked: {
      color: #181818;
  }
}
  .checkbox:hover {
    background: white;
  }

  .clickable-label {
    color: #0d0d0e;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .clickable-label:hover {
    text-decoration: underline;
  }

  .add-icon {
    margin-right: 5px;
  }

  .custom-input,
  .custom-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    ::-webkit-input-placeholder { 
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    }

    ::-moz-placeholder { 
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      color: #C8C8C8;
    }

    font-family: ${RobotoFont.style.fontFamily}, sans-serif ;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    border: 1px solid #D7D7D7;
    padding: 12px 20px;
    border-radius: 2px;
    outline: none;
    flex: 1;
    color: #C8C8C8;
    margin: 0;
  }

  .custom-input::placeholder {
    color: #C8C8C8;
  }

  .custom-input {
    .PhoneInputCountrySelect {
      overflow: auto;
      overflow-y: auto;
      height: 50px;

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      ::-webkit-scrollbar-track {
        border-radius: 5px;
        background-color: #e4e6ef;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #cccccc;
      }

      scrollbar-width: 6px;
      scrollbar-height: 6px;
      scrollbar-color: #cccccc #e4e6ef;
    }

    input {
      outline: none;
      border: none;
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #C8C8C8;
    }

    input::placeholder {
      outline: none;
      border: none;
      font-family: ${RobotoFont.style.fontFamily}, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #C8C8C8;
    }

    select {
      max-height: 130px;
    }
  }

  .custom-button {
    background-color: #0d0d0e;
    border-radius: 50px;
    color: #ffffff;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    margin-block: 24px;
    width: ${forModal ? '100%' : '35%'};
    align-self: center;
    cursor: pointer;
  }

  
  .custom-button-disabled {
    background-color: #ffffff;
    border-radius: 50px;
    color: #0d0d0e;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    margin-block: 24px;
    width: ${forModal ? '100%' : '35%'};
    align-self: center;
    cursor: pointer;
  }

  .custom-hr {
    margin: 12px 0;
    background-color: #0d0d0e;
    height: 1px;
    border: none;
    @media screen and (max-width: 768px) {
      margin: 18px 0;
    }
  }

  .custom-hr-step-mobile {
    @media screen and (max-width: 768px) {
      margin: 0;
    }
  }
  .hr-sell-form-2 {
    @media screen and (max-width: 768px) {
      margin: 6px 0;
    }
  }
  .hr-sell-form-2-bottom {
    @media screen and (max-width: 768px) {
      margin: 12px 0 6px !important;
    }
  }

  .custom-hr-step-mobile-3 {
    @media screen and (max-width: 768px) {
      margin: 6px 0;
    }
  }

  .clickable-label-step-2 {
    @media screen and (max-width: 768px) {
      margin-bottom: 60px;
    }
  }
  .clickable-label-sell {
    @media screen and (max-width: 768px) {
      margin: 6px 0 13px;
    }
  }

  .clickable-label-step-3 {
    @media screen and (max-width: 768px) {
      margin: 6px 0;
    }

  }

  .step-3-for-modal {
    margin: 0 !important;
  }

  .gray-hr {
    background-color: #808080;
    margin: 0;
    @media screen and (max-width: 768px) {
      margin: 6px 0;
    }
  }

  .gray-hr-bottom {
    background-color: #808080;
    margin: 0;
    @media screen and (max-width: 768px) {
      margin: 6px 0;
    }
  }

  .custom-select {
    padding: 0;
  }

  .phone-select {
    flex: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
    min-width: 70px;
    max-width: 70px;
  }

  .currency-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
    max-width: 100px;
  }

  .phone-input {
    flex: 3;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
    padding-left: 0;
    min-width: 0;
  }

  .upload-files {
    @media screen and (max-width: 768px) {
      margin-bottom: 6px;
    }
  }

  .phone-code-input {
    flex: 0;
    border-radius: 0;
    border-right: none;
    padding-right: 0;
    width: 70px;
  }

  .currency-input {
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .label-wrapper {
    display: flex;
    justify-content: space-between;
    padding-right: 36px;
  }

  .group-container {
    display: flex;
    width: 100;
  }

  .price-container {
    margin-top: 0px; 
    @media screen and (max-width: 768px) {
      margin-bottom: 6px;
    }
  }



  .text-area {
    resize: vertical;
    min-height: 100px;
    padding: 10px 20px;

    ::-webkit-resizer {
      display: none;
    }
  }

  .commission-desc {
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    text-align: justify;
    width: ${forModal ? '100%' : '60%'};
    white-space: pre-wrap;
    margin-bottom: 48px;

    @media screen and (max-width: 600px) {
      width: 90%;
    }
  }

  .info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    width: 60%;
    flex: 1;
  }

  .image-names {
    color: #0d0d0e;
    padding-top:24px;
    width:100%;
  }

  .image-name {
    position: relative;
    background-color: #f2f2f3;
    width: fit-content;
    border-radius: 4px;
    padding: 8px 26px 8px 12px;
    min-width: 200px;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 12px;
    max-width: 100%;
    white-space:wrap;

    @media only screen and (max-width: 768px) {
      font-size: 12px;
    }
  }

  .close-icon {
    position: absolute;
    right: 10px;
    top: 9px;
    cursor: pointer;
  }

  .currency-input-for-modal {
    max-width:calc(100% - 100px);
  }

  @media screen and (max-width: 1300px) {
    padding: 0 32px;
    .form-container,
    .info-container {
      width: ${forModal ? '100%' : '90%'};
    }

    .label-wrapper {
      padding-right: 36px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: ${forModal ? '0' : '0 32px'};
  }

  @media screen and (max-width: 855px) {
    .form-row {
      flex-direction: column;
    }

    .input-wrapper-right {
      margin: 0;
    }

    .custom-button {
      width: 100%;
    }

    .currency-select{
      min-width: 80px;
    }

    .currency-input {
      max-width:calc(100% - 100px);
    } 
  }

  @media screen and (max-width: 600px) {
    .label-wrapper {
      padding: 0;
    }
  }

  .phone-or-email {
    margin-block:12px -10px;
    font-size: 14px;
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-weight: 500;
    color: #7d8286;
    @media only screen and (min-width:855px) {
      display: none;
    }
  }

  .add-watch-span {
    margin-left: 8px;
    font-size: 16px;
    letter-spacing: 2px;
    color: #000000;
  }

  .add-watch-span-for-modal {
    margin-left: 8px;
    font-size: 16px;
    letter-spacing: 2px;
    color: #000000;
    text-transform: uppercase;

  }
`
);
